<template>
  <a-modal v-model:visible="visible" :title="$t('pleaseSelectPersonal')" :closable="false" :maskClosable="false">
    <select-id-and-name :list="personalList" option-text="name" option-value="id" v-model:value="personalId">

    </select-id-and-name>
    <template #footer>
      <a-button key="submit" type="primary" @click="handleOk">{{ $t("confirm") }}</a-button>
    </template>
  </a-modal>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/12/14 13:26
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import SelectIdAndName from "@/components/public/selectIdAndName.vue";

export default {
  name: "selectPersonal",
  components: {SelectIdAndName, VLoading},
  data() {
    return {
      loading: false,
      visible : false,
      personalList : [],
      personalId : "",
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    handleOk(){
      if (util.isNull(this.personalId)){
        util.error("pleaseSelectPersonal")
        return;
      }
      this.$emit("selectPersonal", this.personalId);
      this.visible = false;
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {}
      util.$post("/personal/selectPersonal", post, (res) => {
        this.personalList = res.personalList;
        this.visible = true;
      }, this.showMask, this.hideMask);
    }
  }
}
</script>

<style scoped>

</style>